import React from "react"
import PropTypes from "prop-types"
import Container from "../Container"
import FooterTop from "./FooterTop"
import FooterBottom from "./FooterBottom"

import { useI18next } from "gatsby-plugin-react-i18next"
import "./Footer.less"

// Temporary Data
import { SocialLinkData } from "../../dummy/Global"

function Footer(props) {
  const { t } = useI18next()
  const FooterMenuData = [
    {
      text: t("Peta Situs"),
      url: "/peta-situs",
    },
    {
      text: t("Hubungi Kami"),
      url: "/informasi/hubungi-kami/",
    },
    {
      text: t("Prasyarat"),
      url: "/prasyarat",
    },
    {
      text: t("FAQ"),
      url: "https://bantuan.lpdp.kemenkeu.go.id/kb",
    },
  ]
  const OtherWebData = [
    {
      text: t("Website Kemenkeu"),
      url: "https://www.kemenkeu.go.id/home",
    },
    {
      text: t("Sekretariat Jenderal"),
      url: "https://setjen.kemenkeu.go.id/in/home",
    },
    {
      text: t("Inspektorat Jenderal"),
      url: "http://www.itjen.kemenkeu.go.id/",
    },
    {
      text: t("Direktorat Jenderal Anggaran"),
      url: "https://anggaran.kemenkeu.go.id/in/home",
    },
    {
      text: t("Direktorat Jenderal Pajak"),
      url: "https://www.pajak.go.id/",
    },
    {
      text: t("Direktorat Jenderal Bea Cukai"),
      url: "https://www.beacukai.go.id/",
    },
    {
      text: t("Direktorat Jenderal Perbendaharaan"),
      url: "https://djpb.kemenkeu.go.id/portal/id/",
    },
    {
      text: t("Direktorat Jenderal Kekayaan Negara"),
      url: "https://www.djkn.kemenkeu.go.id/ ",
    },
    {
      text: t("Direktorat Jenderal Perimbangan Keuangan"),
      url: "http://www.djpk.kemenkeu.go.id/",
    },
    {
      text: t("Direktorat Jenderal Pengelolaan Pembiayaan dan Risiko"),
      url: "https://www.djppr.kemenkeu.go.id/#/id/page/home",
    },
    {
      text: t("Badan Kebijakan Fiskal"),
      url: "https://www.fiskal.kemenkeu.go.id/",
    },
    {
      text: t("Badan Pendidikan dan Pelatihan Keuangan"),
      url: "https://bppk.kemenkeu.go.id/",
    },
  ]
  return (
    <footer className={`footer ${props.theme}`}>
      <div className="footer-top">
        <Container>
          <FooterTop footerMenu={FooterMenuData} />
        </Container>
      </div>
      <div className="footer-bottom">
        <FooterBottom socialLink={SocialLinkData} otherWebsite={OtherWebData} />
      </div>
    </footer>
  )
}

Footer.prototypes = {
  theme: PropTypes.oneOf(["cream", "blue"]),
}

Footer.defaultProps = {
  theme: "cream",
}

export default Footer
